// Overlay helper for #SideDrawer / size-sheet.
// WHILE open: lock document scroll with overflow:hidden on html+body only.
// Do NOT set height:100dvh or position:fixed on body (those collapsed the
// drawer on iPhone / stuck as the old PDP killer when left behind).
// WHILE closed: strip lock styles/classes and restore scrollY. Never leave
// sc-overlay-open or overflow:hidden stuck. Restore paths: X, overlay, ESC,
// inert, node removed, pageshow, popstate.
//
// Observers must never re-enter from our own style/class writes, and must
// never watch body subtree (PR 5 hang). A syncing flag alone cannot stop a
// loop because MutationObserver callbacks run AFTER the current stack.
(function (w) {
  var count = 0;
  var applied = false;
  var savedY = 0;
  var syncing = false;
  var ignoring = false;
  var scheduled = false;
  var observers = [];
  var ATTR_OPTS = { attributes: true, attributeFilter: ['style', 'class'] };
  var CHILD_OPTS = { childList: true, subtree: false };
  var DRAWER_ATTR_OPTS = { attributes: true, attributeFilter: ['class'] };
  var DOC_LOCK_RE = /overflow|position\s*:|touch-action|overscroll|padding-right|margin-right|height\s*:|width\s*:|top\s*:/i;
  var WRAP_LOCK_RE = /overflow|position\s*:|touch-action|overscroll|padding-right|margin-right/i;
  var STYLE_PROPS = [
    'overflow', 'overflowX', 'overflowY', 'position', 'top', 'left', 'right',
    'bottom', 'width', 'height', 'maxHeight', 'touchAction', 'overscrollBehavior',
    'paddingRight', 'marginRight'
  ];
  var CSS_PROPS = [
    'overflow', 'overflow-x', 'overflow-y', 'position', 'top', 'left', 'right',
    'bottom', 'width', 'height', 'max-height', 'touch-action', 'overscroll-behavior',
    'padding-right', 'margin-right'
  ];
  var WRAP_STYLE_PROPS = [
    'overflow', 'overflowX', 'overflowY', 'position', 'top', 'left', 'right',
    'touchAction', 'overscrollBehavior', 'paddingRight', 'marginRight'
  ];
  var WRAP_CSS_PROPS = [
    'overflow', 'overflow-x', 'overflow-y', 'position', 'top', 'left', 'right',
    'touch-action', 'overscroll-behavior', 'padding-right', 'margin-right'
  ];
  var APP_OVERLAY_SEL = [
    '#slidecarthq',
    '[id*="slidecart"]',
    '[id*="SlideCart"]',
    '#upsell-options-overlay',
    '.upsell-options-overlay',
    '[id*="upsell-options"]',
    '[class*="upsell-options-overlay"]',
    '.boost-sd__modal'
  ].join(',');
  var PAGE_WRAP_SEL = '#PageContainer, #MainContent, .page-container, .transition-body, .main-content';

  function isDbgNode(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.id === 'scrolldbg') return true;
    return !!(node.closest && node.closest('#scrolldbg'));
  }

  function isShown(el) {
    if (!el) return false;
    if (el.style && el.style.display === 'none') return false;
    try {
      var cs = w.getComputedStyle(el);
      return cs.display !== 'none' && cs.visibility !== 'hidden';
    } catch (err) {
      return true;
    }
  }

  function visibleOpenDrawer() {
    var drawers = document.querySelectorAll('.drawer.drawer--is-open');
    var i, el;
    for (i = 0; i < drawers.length; i++) {
      el = drawers[i];
      if (el.id === 'CartDrawer') continue;
      if (isShown(el)) return el;
    }
    return null;
  }

  // Impulse #CartDrawer also opens on ajaxProduct:added (cart_type=drawer).
  // If it stays .drawer--is-open after the theme ATC popup closes — or is
  // merely hidden with display:none — html.js-drawer-open { overflow:hidden }
  // sticks and iOS cannot pan the product page.
  function closeImpulseCartDrawer() {
    var cart = document.getElementById('CartDrawer');
    if (cart && cart.classList.contains('drawer--is-open')) {
      try { document.dispatchEvent(new CustomEvent('cart:close')); } catch (err) {}
      cart.classList.remove('drawer--is-open');
    }
    if (!visibleOpenDrawer()) {
      var html = document.documentElement;
      if (html) html.classList.remove('js-drawer-open', 'js-drawer-open--search', 'js-drawer-closing');
    }
  }

  function themeModalOpen() {
    var drawer = document.getElementById('SideDrawer');
    if (drawer && drawer.classList.contains('is-open')) return true;
    if (document.querySelector('.size-sheet.is-open')) return true;
    if (isShown(document.querySelector('.sizeguide_wrapper'))) return true;
    if (document.querySelector('.sizeguide-popup.showing')) return true;
    if (visibleOpenDrawer()) return true;
    if (document.querySelector('.modal--is-active')) return true;
    return false;
  }

  function wantLock() {
    return count > 0 || themeModalOpen();
  }

  function strip(node, re, styleProps, cssProps) {
    if (!node || !node.style) return;
    var st = node.getAttribute('style');
    if (!st || !re.test(st)) return;
    styleProps.forEach(function (prop) { node.style[prop] = ''; });
    cssProps.forEach(function (prop) { node.style.removeProperty(prop); });
    if (!(node.getAttribute('style') || '').trim()) node.removeAttribute('style');
  }

  function overlayAlreadyHidden(el) {
    return el.style.getPropertyValue('display') === 'none'
      && el.style.getPropertyPriority('display') === 'important'
      && el.style.getPropertyValue('pointer-events') === 'none'
      && el.style.getPropertyValue('visibility') === 'hidden';
  }

  function hideAppOverlays() {
    try {
      document.querySelectorAll(APP_OVERLAY_SEL).forEach(function (el) {
        if (isDbgNode(el)) return;
        if (el.id === 'SideDrawer' || (el.closest && el.closest('#SideDrawer'))) return;
        if (overlayAlreadyHidden(el)) return;
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.setAttribute('aria-hidden', 'true');
      });
    } catch (err) {}
  }

  function isCartTemplate() {
    return !!(document.body && document.body.classList.contains('template-cart'));
  }

  function htmlBodyLooksLocked() {
    var html = document.documentElement;
    var body = document.body;
    if (!html || !body) return false;
    if (html.classList.contains('sc-overlay-open')) return true;
    if (html.classList.contains('sc-drawer-scroll-lock') || body.classList.contains('sc-drawer-scroll-lock')) return true;
    if (html.classList.contains('lock-scroll') || html.classList.contains('js-side-drawer-open')) return true;
    if (body.classList.contains('lock-scroll')) return true;
    // Only real scroll-lock signals — NOT width/height/top (those false-trigger
    // restoreDocument → scrollTo on /cart and feel like broken native scroll).
    var st = (html.getAttribute('style') || '') + (body.getAttribute('style') || '');
    return /overflow(?:-x|-y)?\s*:\s*hidden|position\s*:\s*fixed|touch-action\s*:\s*none/i.test(st);
  }

  function readStoredY() {
    var body = document.body;
    if (body && body.dataset.drawerScrollY != null) {
      return parseInt(body.dataset.drawerScrollY, 10) || 0;
    }
    if (applied) return savedY;
    var top = body && body.style.top;
    if (top && /px$/i.test(top)) return Math.abs(parseInt(top, 10) || 0);
    return w.scrollY || w.pageYOffset || 0;
  }

  function applyDocumentLock() {
    var html = document.documentElement;
    var body = document.body;
    if (!html || !body) return;
    hideAppOverlays();
    if (!applied) {
      savedY = w.scrollY || w.pageYOffset || 0;
      body.dataset.drawerScrollY = String(savedY);
      applied = true;
    } else if (body.dataset.drawerScrollY == null) {
      body.dataset.drawerScrollY = String(savedY);
    }
    html.classList.remove('sc-overlay-open', 'js-side-drawer-open', 'lock-scroll');
    body.classList.remove('lock-scroll', 'js-side-drawer-open');
    closeImpulseCartDrawer();
    // Strip leftover app locks first, then apply our controlled document lock.
    // Only overflow:hidden — no height/position:fixed (iOS/SideDrawer regressions).
    strip(body, DOC_LOCK_RE, STYLE_PROPS, CSS_PROPS);
    strip(html, DOC_LOCK_RE, STYLE_PROPS, CSS_PROPS);
    html.style.setProperty('overflow', 'hidden');
    body.style.setProperty('overflow', 'hidden');
    html.classList.add('sc-drawer-scroll-lock');
    body.classList.add('sc-drawer-scroll-lock');
    if (isCartTemplate()) connectObservers();
  }

  function restoreDocument() {
    var html = document.documentElement;
    var body = document.body;
    var restoreY = readStoredY();
    var hadLock = applied || htmlBodyLooksLocked();
    closeImpulseCartDrawer();
    if (html) {
      html.classList.remove('sc-overlay-open', 'js-side-drawer-open', 'lock-scroll', 'sc-drawer-scroll-lock');
      if (!visibleOpenDrawer()) {
        html.classList.remove('js-drawer-open', 'js-drawer-open--search', 'js-drawer-closing');
      }
      if (!document.querySelector('.modal--is-active')) {
        html.classList.remove('modal-open', 'modal-open--solid', 'modal-closing');
      }
    }
    if (body) body.classList.remove('sc-drawer-scroll-lock');
    strip(html, DOC_LOCK_RE, STYLE_PROPS, CSS_PROPS);
    strip(body, DOC_LOCK_RE, STYLE_PROPS, CSS_PROPS);
    try {
      document.querySelectorAll(PAGE_WRAP_SEL).forEach(function (node) {
        if (isDbgNode(node)) return;
        strip(node, WRAP_LOCK_RE, WRAP_STYLE_PROPS, WRAP_CSS_PROPS);
      });
    } catch (err) {}
    if (body) {
      if (body.dataset.drawerScrollY != null) delete body.dataset.drawerScrollY;
      body.classList.remove('lock-scroll', 'js-side-drawer-open');
    }
    applied = false;
    savedY = 0;
    hideAppOverlays();
    if (isCartTemplate()) disconnectObservers();
    if (!hadLock) return;
    w.scrollTo(0, restoreY);
    var replay = function () {
      if (!html || html.classList.contains('sc-overlay-open')) return;
      w.scrollTo(0, restoreY);
    };
    if (typeof w.requestAnimationFrame === 'function') w.requestAnimationFrame(replay);
    else w.setTimeout(replay, 0);
  }

  function disconnectObservers() {
    observers.forEach(function (obs) { obs.disconnect(); });
    observers = [];
  }

  function recordsAreOurs(records) {
    var i;
    for (i = 0; i < records.length; i++) {
      if (!isDbgNode(records[i].target)) return false;
    }
    return records.length > 0;
  }

  function observe(node, opts) {
    if (!node || typeof MutationObserver === 'undefined') return;
    var obs = new MutationObserver(function (records) {
      if (ignoring || syncing) return;
      if (recordsAreOurs(records)) return;
      var i, j, removed, node;
      for (i = 0; i < records.length; i++) {
        removed = records[i].removedNodes;
        if (!removed) continue;
        for (j = 0; j < removed.length; j++) {
          node = removed[j];
          if (node && node.id === 'SideDrawer') {
            count = 0;
            syncLock();
            return;
          }
        }
      }
      scheduleSync();
    });
    obs.observe(node, opts);
    observers.push(obs);
  }

  function connectObservers() {
    if (typeof MutationObserver === 'undefined') return;
    disconnectObservers();
    observe(document.documentElement, ATTR_OPTS);
    if (document.body) {
      observe(document.body, ATTR_OPTS);
      observe(document.body, CHILD_OPTS);
    }
    var drawer = document.getElementById('SideDrawer');
    if (drawer) observe(drawer, DRAWER_ATTR_OPTS);
  }

  function withMutationsIgnored(fn) {
    ignoring = true;
    disconnectObservers();
    try {
      fn();
    } finally {
      connectObservers();
      ignoring = false;
    }
  }

  function syncLock() {
    if (syncing || ignoring) return;
    syncing = true;
    try {
      withMutationsIgnored(function () {
        // Apps may delete #SideDrawer without a matching release(). Drop a
        // leftover count when no theme overlay is actually open so restore runs.
        if (!themeModalOpen()) count = 0;
        if (wantLock()) {
          applyDocumentLock();
        } else if (applied) {
          // Only unwind a lock WE applied. Idle /cart must not strip wrappers
          // or scrollTo — that is the cart native-scroll killer.
          restoreDocument();
        } else if (!isCartTemplate() && htmlBodyLooksLocked()) {
          restoreDocument();
        }
      });
    } finally {
      syncing = false;
    }
  }

  function scheduleSync() {
    if (scheduled || syncing || ignoring) return;
    scheduled = true;
    var run = function () {
      scheduled = false;
      syncLock();
    };
    if (typeof w.requestAnimationFrame === 'function') w.requestAnimationFrame(run);
    else w.setTimeout(run, 0);
  }

  w.scPageLock = {
    acquire: function () {
      count += 1;
      syncLock();
    },
    release: function () {
      count = Math.max(0, count - 1);
      syncLock();
    },
    force: function () {
      count = 0;
      syncLock();
    },
    sync: syncLock,
    themeModalOpen: themeModalOpen,
    hideAppOverlays: hideAppOverlays,
    closeImpulseCartDrawer: closeImpulseCartDrawer,
    isApplied: function () { return applied; },
    savedY: function () { return savedY; }
  };

  function bootWatchers() {
    // /cart: leave native document scroll alone until #SideDrawer opens.
    // Observers + boot sync/strip/scrollTo were fighting the page (Timm A/B:
    // commenting out custom.js fixed cart scroll).
    if (isCartTemplate()) return;
    connectObservers();
    syncLock();
    w.setTimeout(function () { syncLock(); }, 0);
    w.setTimeout(function () { syncLock(); }, 1200);
  }
  if (document.body) bootWatchers();
  else document.addEventListener('DOMContentLoaded', bootWatchers);

  w.addEventListener('pageshow', function (evt) {
    if (evt.persisted) count = 0;
    scheduleSync();
  });
  w.addEventListener('pagehide', function () {
    if (!wantLock()) scheduleSync();
  });
  w.addEventListener('popstate', function () {
    if (!wantLock()) {
      count = 0;
      scheduleSync();
    }
  });
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) scheduleSync();
  });
  function touchMaybeUnlock() {
    if (wantLock()) return;
    if (isCartTemplate() && !applied) return;
    if (htmlBodyLooksLocked()) scheduleSync();
  }
  w.addEventListener('touchend', touchMaybeUnlock, { passive: true });

  function disarmThemeScrollLock() {
    if (!w.theme || !theme.a11y) return;
    theme.a11y.lockMobileScrolling = function () {};
    theme.a11y.unlockMobileScrolling = function () {
      document.documentElement.classList.remove('lock-scroll');
    };
  }
  disarmThemeScrollLock();
  document.addEventListener('DOMContentLoaded', disarmThemeScrollLock);

  // Impulse CartDrawer opens on the same ajaxProduct:added as #SideDrawer.
  // Close it after it opens so html.js-drawer-open cannot outlive the popup.
  document.addEventListener('ajaxProduct:added', function () {
    w.setTimeout(function () {
      if (document.getElementById('SideDrawer')) closeImpulseCartDrawer();
    }, 0);
  });
})(window);

$(function() {
  function unlockSizeguideScroll() {
    if (window.scPageLock) window.scPageLock.release();
    else document.documentElement.classList.remove('sc-overlay-open');
  }

  $('.sizeguide_toggler, .sizeguide_wrapper--close').click(() => {
      if ($('.sizeguide_wrapper').is(':visible')) {
        $('.sizeguide_wrapper').hide();
        unlockSizeguideScroll();
    } else {
        $('.sizeguide_wrapper').show();

        if ( window.innerWidth <= 768 ) {
            if (window.scPageLock) window.scPageLock.acquire();
        }
      }
  });

  // Scrolling the window will close the popup
  $(window).scroll(() => {
      if ( window.innerWidth > 768 && $('.sizeguide_wrapper').is(':visible') ) {
          $('.sizeguide_wrapper').hide();
          unlockSizeguideScroll();
      }
  });

  // Clicks outside the wrapper will close the popup
  $(document).mouseup(e => {
      if (!$('.sizeguide_wrapper').is(':visible')) return;
      if (!$('.sizeguide_wrapper').is(e.target) && $('.sizeguide_wrapper').has(e.target).length === 0) {
          $('.sizeguide_wrapper').hide();
          unlockSizeguideScroll();
      }
  });

}); // DOM Loaded

// Cart page line-item remove button -> set quantity to 0 via the change URL.
document.addEventListener('click', function (evt) {
  var btn = evt.target.closest('[data-cart-remove]');
  if (!btn) return;
  evt.preventDefault();
  btn.classList.add('is-loading');
  fetch(btn.dataset.cartRemove, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
    .then(function () { window.location.reload(); })
    .catch(function (err) { btn.classList.remove('is-loading'); console.error(err); });
});

// At quantity 1 the minus button turns into a remove (X). Handle it in the capture
// phase so the theme's own decrement handler on the same button never fires.
document.addEventListener('click', function (evt) {
  var removeMinus = evt.target.closest('.cart__qty--single .js-qty__adjust--minus');
  if (!removeMinus) return;
  evt.preventDefault();
  evt.stopImmediatePropagation();
  var url = removeMinus.getAttribute('data-cart-remove');
  if (!url) return;
  var wrapper = removeMinus.closest('.js-qty__wrapper');
  if (wrapper) { wrapper.classList.add('is-loading'); }
  fetch(url, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
    .then(function () { window.location.reload(); })
    .catch(function (err) { console.error(err); });
}, true);

// Cart page: quantity +/- handler independent of the theme CartForm (which does
// not initialize on the redesigned cart page). Capture phase pre-empts the theme
// stepper; POST the change then reload so the summary and totals stay correct.
document.addEventListener('click', function (evt) {
  var btn = evt.target.closest('.cart__page-col--items .js-qty__adjust');
  if (!btn) return;
  // Single-qty minus removes the line and is handled by its own listener above.
  if (btn.classList.contains('cart__qty-remove')) return;
  var wrapper = btn.closest('.js-qty__wrapper');
  var input = wrapper && wrapper.querySelector('.js-qty__num');
  if (!input) return;
  evt.preventDefault();
  evt.stopImmediatePropagation();
  var current = parseInt(input.value, 10) || 1;
  var next = btn.classList.contains('js-qty__adjust--plus') ? current + 1 : current - 1;
  if (next < 1) next = 1;
  if (next === current) return;
  wrapper.classList.add('is-loading');
  fetch(theme.routes.cartChange, {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ id: input.dataset.id, quantity: next })
  })
    .then(function (res) {
      if (res.ok) { window.location.reload(); return; }
      wrapper.classList.remove('is-loading');
      // Shopify answers 422 when the quantity exceeds available stock.
      if (res.status === 422) {
        wrapper.closest('.cart__item-actions').parentElement.querySelector('[data-qty-error]').hidden = false;
        return;
      }
      throw new Error('Cart quantity change failed with status ' + res.status);
    })
    .catch(function (err) { wrapper.classList.remove('is-loading'); console.error(err); });
}, true);

// Cart page: sync sticky summary col top with header height
(function () {
  if (!document.body.classList.contains('template-cart')) return;
  function updateStickyTop() {
    var header = document.querySelector('#HeaderWrapper') || document.querySelector('.site-header');
    if (!header) return;
    document.documentElement.style.setProperty('--cart-sticky-top', (header.offsetHeight + 10) + 'px');
  }
  updateStickyTop();
  window.addEventListener('resize', updateStickyTop);
  window.addEventListener('load', updateStickyTop);
})();

// Cart page (mobile): sticky checkout CTA. Hide it once the real checkout button
// scrolls into view so it "lands in its place" in the summary box.
(function () {
  if (!document.body.classList.contains('template-cart')) return;
  var sticky = document.querySelector('[data-sticky-cta]');
  var realBtn = document.querySelector('.cart__actions-row .cart__checkout');
  if (!sticky || !realBtn || !('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(function (entries) {
    sticky.classList.toggle('is-hidden', entries[0].isIntersecting);
  }, { threshold: 0 });
  observer.observe(realBtn);
})();

// Cart page: price stays beside the product name on all breakpoints.

// Horizontal product sliders (cart recs + drawer upsell rail).
// Touch: native overflow-x on the element. Never preventDefault on touchmove —
// that permanently jails iOS document pan after the drawer closes, and it
// also swallows product-link taps.
// Desktop: mouse drag via scrollLeft; suppress mis-clicks only after real movement.
function bindCartHScroll(el) {
  if (!el || el.dataset.hScrollBound) return;
  el.dataset.hScrollBound = '1';

  el.querySelectorAll('img').forEach(function (img) {
    img.draggable = false;
    img.setAttribute('draggable', 'false');
  });
  el.addEventListener('dragstart', function (evt) { evt.preventDefault(); });

  var isTouchSlider = window.matchMedia('(hover: none) and (pointer: coarse)').matches
    || window.matchMedia('(max-width: 768px)').matches;
  if (isTouchSlider) return;

  el.addEventListener('wheel', function (evt) {
    if (el.scrollWidth <= el.clientWidth + 1) return;
    if (Math.abs(evt.deltaX) <= Math.abs(evt.deltaY)) return;
    el.scrollLeft += evt.deltaX;
    if (evt.cancelable) evt.preventDefault();
  }, { passive: false });

  var startX = 0;
  var lastX = 0;
  var startY = 0;
  var axis = null;
  var dragging = false;
  var movedX = 0;
  var pointerId = null;
  var AXIS_THRESHOLD = 10;
  var CLICK_SUPPRESS_PX = 12;

  function finishDrag() {
    var didDrag = dragging && movedX >= CLICK_SUPPRESS_PX;
    dragging = false;
    axis = null;
    movedX = 0;
    pointerId = null;
    el.classList.remove('is-dragging');
    if (didDrag) {
      el.addEventListener('click', function (clickEvt) {
        clickEvt.preventDefault();
        clickEvt.stopPropagation();
      }, { capture: true, once: true });
    }
  }

  el.addEventListener('pointerdown', function (evt) {
    if (el.scrollWidth <= el.clientWidth + 1) return;
    if (evt.pointerType !== 'mouse' || evt.button !== 0) return;
    if (evt.target.closest('button, input, [data-stl-sizes]')) return;
    startX = lastX = evt.clientX;
    startY = evt.clientY;
    axis = null;
    dragging = false;
    movedX = 0;
    pointerId = evt.pointerId;
  });

  el.addEventListener('pointermove', function (evt) {
    if (pointerId !== evt.pointerId) return;
    var totalX = evt.clientX - startX;
    var totalY = evt.clientY - startY;
    if (!axis) {
      if (Math.abs(totalX) < AXIS_THRESHOLD && Math.abs(totalY) < AXIS_THRESHOLD) return;
      if (Math.abs(totalX) < Math.abs(totalY)) {
        pointerId = null;
        return;
      }
      axis = 'x';
      dragging = true;
      el.classList.add('is-dragging');
      try { el.setPointerCapture(evt.pointerId); } catch (err) {}
    }
    if (axis === 'x') {
      var dx = evt.clientX - lastX;
      el.scrollLeft -= dx;
      movedX += Math.abs(dx);
      lastX = evt.clientX;
    }
  }, { passive: true });

  function endDrag(evt) {
    if (pointerId == null) return;
    if (evt && evt.pointerId != null && evt.pointerId !== pointerId) return;
    finishDrag();
  }

  el.addEventListener('pointerup', endDrag);
  el.addEventListener('pointercancel', endDrag);
  el.addEventListener('lostpointercapture', endDrag);
}

// Cart drawer enhancements: free-shipping bar + recommendations carousel.
(function () {
  var freeShippingBars = document.querySelectorAll('[data-free-shipping]');
  var recsContainer = document.querySelector('[data-cart-recommendations]');
  var totalDiscount = document.querySelector('[data-cart-total-discount]');
  if (!freeShippingBars.length && !recsContainer && !totalDiscount) return;

  var RECS_SECTION = 'cart-recommendations';
  var lastRecsProductId = null;

  // --- Free-shipping bar ---
  function updateFreeShipping(cart) {
    var total = cart.total_price;
    freeShippingBars.forEach(function (bar) {
      var threshold = parseInt(bar.dataset.threshold, 10);
      if (!threshold) return;
      var textEl = bar.querySelector('[data-free-shipping-text]');
      var fillEl = bar.querySelector('[data-free-shipping-fill]');
      var pct = Math.min(100, Math.round((total / threshold) * 100));
      if (fillEl) { fillEl.style.width = pct + '%'; }
      if (total >= threshold) {
        bar.classList.add('cart-free-shipping--unlocked');
        if (textEl) { textEl.textContent = bar.dataset.textUnlocked; }
      } else {
        bar.classList.remove('cart-free-shipping--unlocked');
        var remaining = theme.Currency.formatMoney(threshold - total, theme.settings.moneyFormat);
        if (textEl) { textEl.textContent = bar.dataset.textRemaining.replace('[amount]', remaining); }
      }
    });
    var shippingRow = document.querySelector('[data-shipping-row]');
    if (shippingRow) {
      var rowThreshold = parseInt(shippingRow.dataset.thresholdCents, 10);
      var shippingCost = parseInt(shippingRow.dataset.shippingCostCents, 10);
      var valueEl = shippingRow.querySelector('[data-shipping-value]');
      if (valueEl && rowThreshold) {
        if (total >= rowThreshold) {
          valueEl.textContent = shippingRow.dataset.textFree || 'Gratis';
        } else {
          valueEl.textContent = theme.Currency.formatMoney(shippingCost, theme.settings.moneyFormat).replace(/<[^>]*>/g, '');
        }
      }
    }
  }

  // --- Recommendations carousel ---
  function fetchRecs(productId, intent) {
    var url = '/recommendations/products?section_id=' + RECS_SECTION +
      '&product_id=' + productId + '&limit=10&intent=' + intent;
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) { throw new Error('Recommendations fetch failed: ' + r.status); }
      return r.text();
    });
  }

  function recsNode(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector('.cart-recs');
  }

  function renderRecs(node) {
    recsContainer.replaceChildren(node);
    if (!window.matchMedia('(max-width: 768px)').matches) {
      recsContainer.classList.add('cart-recs--pending');
    }
    initCarousel();
  }

  function loadRecs(cart) {
    if (!recsContainer) return;
    if (!cart.items.length) {
      recsContainer.replaceChildren();
      lastRecsProductId = null;
      return;
    }
    var productId = cart.items[0].product_id;
    if (productId === lastRecsProductId && recsContainer.children.length) return;
    fetchRecs(productId, 'complementary').then(function (html) {
      var node = recsNode(html);
      if (node) { lastRecsProductId = productId; renderRecs(node); return; }
      return fetchRecs(productId, 'related').then(function (relHtml) {
        var relNode = recsNode(relHtml);
        if (relNode) { lastRecsProductId = productId; renderRecs(relNode); }
        else { recsContainer.replaceChildren(); lastRecsProductId = null; }
      });
    }).catch(function (err) {
      console.error(err);
      recsContainer.replaceChildren();
      lastRecsProductId = null;
    });
  }

  function initCarousel() {
    var track = recsContainer.querySelector('[data-recs-track]');
    if (!track) {
      recsContainer.classList.remove('cart-recs--pending');
      return;
    }
    var mobile = window.matchMedia('(max-width: 768px)').matches;
    if (mobile || typeof Flickity !== 'function') {
      recsContainer.classList.remove('cart-recs--pending');
      bindCartHScroll(track);
      return;
    }
    var flkty = new Flickity(track, {
      cellAlign: 'left',
      contain: true,
      groupCells: true,
      pageDots: false,
      wrapAround: false,
      imagesLoaded: true
    });
    function showRecs() { recsContainer.classList.remove('cart-recs--pending'); }
    flkty.on('ready', showRecs);
    setTimeout(showRecs, 800);
  }

  // --- Total discount row ---
  function updateTotalDiscount() {
    if (!totalDiscount) return;
    var amountEl = totalDiscount.querySelector('[data-cart-total-discount-amount]');
    var total = 0;
    document.querySelectorAll('[data-line-savings]').forEach(function (el) {
      total += parseInt(el.dataset.lineSavings, 10) || 0;
    });
    if (total > 0) {
      amountEl.textContent = theme.Currency.formatMoney(total, theme.settings.moneyFormat);
      totalDiscount.classList.remove('hide');
    } else {
      totalDiscount.classList.add('hide');
    }
  }

  // --- Shared refresh ---
  function refresh() {
    if (typeof theme === 'undefined' || !theme.cart) return;
    theme.cart.getCart().then(function (cart) {
      updateFreeShipping(cart);
      updateTotalDiscount();
      loadRecs(cart);
    });
  }

  refresh();
  document.addEventListener('cart:updated', refresh);
  document.addEventListener('cart:build', refresh);

  // The cart page rebuilds [data-products] on qty/remove; re-sum savings then.
  var cartProductsEl = document.querySelector('[data-products]');
  if (cartProductsEl) {
    new MutationObserver(updateTotalDiscount).observe(cartProductsEl, { childList: true });
  }
})();

// Header cart bubble. Impulse CartDrawer used to toggle it, but it is no longer
// instantiated (see theme.js initDrawers), so sync it on every cart change.
(function () {
  function updateCartBubble() {
    theme.cart.getCart().then(function (cart) {
      document.querySelectorAll('.cart-link__bubble').forEach(function (bubble) {
        bubble.classList.toggle('cart-link__bubble--visible', cart.item_count > 0);
      });
    });
  }

  document.addEventListener('cart:build', updateCartBubble);
  document.addEventListener('cart:updated', updateCartBubble);
})();

// Side drawer: Shop the look + add-to-cart notification.
(function () {
  var inertTimer = null;

  function liveDrawer() {
    var el = document.getElementById('SideDrawer');
    return (el && el.isConnected) ? el : null;
  }
  function drawerIsOpen() {
    var el = liveDrawer();
    return !!(el && el.classList.contains('is-open'));
  }
  function unlockPage() {
    if (window.scPageLock) window.scPageLock.force();
  }
  function lockPage(on) {
    if (!window.scPageLock) return;
    if (on) window.scPageLock.acquire();
    else window.scPageLock.release();
  }

  // Flickity/Unidragger binds window touchmove and preventDefault()s drag.
  // If the ATC overlay steals the gesture, those listeners jail page pan.
  function releaseStuckDrags() {
    if (typeof Flickity === 'undefined' || typeof Flickity.data !== 'function') return;
    document.querySelectorAll('.flickity-enabled').forEach(function (el) {
      var flkty = Flickity.data(el);
      if (!flkty) return;
      try {
        if (typeof flkty._pointerDone === 'function') flkty._pointerDone();
        else if (typeof flkty._unbindPostStartEvents === 'function') flkty._unbindPostStartEvents();
      } catch (err) {}
      flkty.isDragging = false;
      el.classList.remove('is-pointer-down');
      var viewport = el.querySelector('.flickity-viewport');
      if (viewport) viewport.classList.remove('is-pointer-down');
    });
  }

  // Capture so overlay/X still unlock if another script removes #SideDrawer
  // during the same click. Never depends on the node remaining in the document.
  document.addEventListener('click', function (evt) {
    var t = evt.target;
    if (!t || !t.closest) return;
    if (!t.closest('#SideDrawer [data-side-drawer-close]')) return;
    var el = liveDrawer();
    if (el) {
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
    }
    if (window.scPageLock && window.scPageLock.closeImpulseCartDrawer) {
      window.scPageLock.closeImpulseCartDrawer();
    }
    unlockPage();
  }, true);

  var drawer = liveDrawer();
  if (!drawer) return;

  var titleEl = drawer.querySelector('[data-side-drawer-title]');
  var countEl = drawer.querySelector('[data-side-drawer-count]');
  var bodyEl = drawer.querySelector('[data-side-drawer-body]');
  var railEl = drawer.querySelector('[data-side-drawer-rail]');
  var footerEl = drawer.querySelector('[data-side-drawer-footer]');
  var scrollEl = drawer.querySelector('[data-side-drawer-scroll]');
  var sizeSheet = drawer.querySelector('[data-size-sheet]');
  var sheetList = drawer.querySelector('[data-size-sheet-list]');
  var sheetAddBtn = drawer.querySelector('[data-size-sheet-add]');
  var sheetProductLink = drawer.querySelector('[data-size-sheet-product]');
  var sheetImage = drawer.querySelector('[data-size-sheet-image]');
  var sheetMedia = sheetImage && sheetImage.parentElement;
  // Shimmer placeholder until the packshot has loaded, then fade it in.
  if (sheetImage) {
    sheetImage.addEventListener('load', function () {
      sheetMedia.classList.add('is-loaded');
    });
  }
  var sheetVariant = null;
  var sizeSheetPanel = sizeSheet && sizeSheet.querySelector('.size-sheet__panel');

  function clearRail() {
    if (!railEl) return;
    railEl.replaceChildren();
    railEl.hidden = true;
  }

  function str(key, fallback) {
    return (window.theme && theme.strings && theme.strings[key]) ? theme.strings[key] : fallback;
  }

  // Pull the size value from a cart line. Shopify option name is "Size"
  // (UI labels are localized, the underlying name is not). Fall back to the
  // full variant title when there is no dedicated size option.
  function lineSize(line) {
    var opts = (line && line.options_with_values) || [];
    for (var i = 0; i < opts.length; i++) {
      if (opts[i] && (opts[i].name || '').toLowerCase() === 'size') return opts[i].value;
    }
    return (line && line.variant_title) || '';
  }

  function setDrawerInert(on) {
    var el = liveDrawer() || drawer;
    if (!el) return;
    if (on) {
      el.classList.add('is-inert');
      el.setAttribute('aria-hidden', 'true');
      try { el.inert = true; } catch (err) {}
    } else {
      el.classList.remove('is-inert');
      el.setAttribute('aria-hidden', 'false');
      try { el.inert = false; } catch (err) {}
    }
  }

  function openDrawer() {
    if (inertTimer) { clearTimeout(inertTimer); inertTimer = null; }
    setDrawerInert(false);
    var el = liveDrawer() || drawer;
    var already = el.classList.contains('is-open');
    el.classList.add('is-open');
    if (!already) lockPage(true);
    if (window.scPageLock && window.scPageLock.closeImpulseCartDrawer) {
      window.scPageLock.closeImpulseCartDrawer();
    }
    releaseStuckDrags();
    if (scrollEl) scrollEl.scrollTop = 0;
    if (railEl) railEl.scrollTop = 0;
  }

  function closeDrawer() {
    var el = liveDrawer() || drawer;
    if (el) {
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
    }
    releaseStuckDrags();
    if (window.scPageLock && window.scPageLock.closeImpulseCartDrawer) {
      window.scPageLock.closeImpulseCartDrawer();
    }
    lockPage(false);
    closeSizeSheet();
    if (inertTimer) clearTimeout(inertTimer);
    inertTimer = setTimeout(function () {
      if (!drawerIsOpen()) setDrawerInert(true);
      inertTimer = null;
    }, 320);
  }
  function forceUnlockPage() {
    if (inertTimer) { clearTimeout(inertTimer); inertTimer = null; }
    var el = liveDrawer() || drawer;
    if (el && el.classList.contains('is-open')) {
      el.classList.remove('is-open');
      closeSizeSheet();
    }
    releaseStuckDrags();
    if (window.scPageLock && window.scPageLock.closeImpulseCartDrawer) {
      window.scPageLock.closeImpulseCartDrawer();
    }
    unlockPage();
    setDrawerInert(true);
  }

  // Make the horizontal size scroll obvious and usable on desktop too.
  function enhanceSizeRows(root) {
    if (!root) return;
    root.querySelectorAll('[data-stl-sizes]').forEach(function (sizes) {
      if (sizes.dataset.singleVariant) return;
      // Don't let a drag on the sizes move the card slider underneath.
      ['pointerdown', 'mousedown', 'touchstart'].forEach(function (type) {
        sizes.addEventListener(type, function (evt) { evt.stopPropagation(); });
      });
      // Desktop has no touch drag: translate vertical wheel into horizontal scroll.
      sizes.addEventListener('wheel', function (evt) {
        if (sizes.scrollWidth <= sizes.clientWidth) return;
        if (Math.abs(evt.deltaY) <= Math.abs(evt.deltaX)) return;
        sizes.scrollLeft += evt.deltaY;
        evt.preventDefault();
      }, { passive: false });
      function updateFades() {
        var max = sizes.scrollWidth - sizes.clientWidth;
        sizes.classList.toggle('can-scroll-left', sizes.scrollLeft > 1);
        sizes.classList.toggle('can-scroll-right', max > 1 && sizes.scrollLeft < max - 1);
      }
      sizes.addEventListener('scroll', updateFades);
      updateFades();
    });
  }

  // Give every slide the tallest cell's height so the slideshow rows line up.
  function equalizeCardHeights(list, flkty) {
    var cells = list.querySelectorAll('.stl-product');
    var max = 0;
    cells.forEach(function (c) { c.style.height = ''; if (c.offsetHeight > max) max = c.offsetHeight; });
    cells.forEach(function (c) { c.style.height = max + 'px'; });
    if (flkty) flkty.resize();
  }

  // Keep the original row layout but slide the cards horizontally, peeking the next row.
  function initCardSlider(list) {
    if (!list || typeof Flickity !== 'function') return;
    if (list.children.length < 2) return; // single card stays a static row
    list.classList.add('stl-look--slider');
    var flkty = new Flickity(list, {
      cellAlign: 'left',
      contain: true,
      freeScroll: true,
      groupCells: false,
      pageDots: false,
      prevNextButtons: false,
      wrapAround: false,
      imagesLoaded: true
    });
    equalizeCardHeights(list, flkty);
    // Images load async and change cell height - re-equalize once each finishes.
    list.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', function () { equalizeCardHeights(list, flkty); }, { once: true });
    });
  }

  function setTitle(text, count) {
    titleEl.textContent = text;
    if (count != null && count !== '') {
      var num = document.createElement('span');
      num.className = 'side-drawer__title-count';
      num.textContent = ' (' + count + ')';
      titleEl.appendChild(num);
    }
  }

  // Total item count in the cart header. Pass null to hide the badge.
  function setCount(n) {
    if (!countEl) return;
    if (n == null) { countEl.hidden = true; countEl.textContent = ''; return; }
    countEl.textContent = n;
    countEl.hidden = false;
  }

  function showCartCount() {
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { 'Cache-Control': 'no-cache' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCount(cart.item_count); })
      .catch(function (err) { console.error(err); });
  }

  function setFooter(nodes) {
    footerEl.replaceChildren();
    if (nodes && nodes.length) {
      nodes.forEach(function (n) { footerEl.appendChild(n); });
      footerEl.hidden = false;
    } else {
      footerEl.hidden = true;
    }
  }

  // --- Shop the look mode (triggered from a cart item) ---
  // Card grid: the cart item leads as an "In your cart" card, the look
  // products follow as upsell-style cards (bag button -> size sheet).
  function openShopTheLook(trigger) {
    var item = trigger.closest('.cart__item');
    var tpl = item && item.querySelector('[data-stl-template]');
    if (!tpl) return;
    drawer.classList.add('side-drawer--stl');
    setTitle(str('shopTheLook', 'Shop the look'));
    setCount(null);

    var wrap = document.createElement('div');
    wrap.className = 'stl-look stl-look--upsell stl-look--grid';

    // Own card: model shot (hover image) + "In your cart" label + title.
    var own = document.createElement('div');
    own.className = 'stl-product stl-product--own';
    var img = item.querySelector('.cart__image-img--hover') || item.querySelector('.cart__image-img');
    var imgSrc = img ? (img.currentSrc || img.src || img.getAttribute('data-src')) : '';
    if (imgSrc) {
      var media = document.createElement('div');
      media.className = 'stl-product__media';
      var ownImg = document.createElement('img');
      ownImg.className = 'stl-product__own-img';
      ownImg.src = imgSrc;
      ownImg.alt = '';
      media.appendChild(ownImg);
      own.appendChild(media);
    }
    var info = document.createElement('div');
    info.className = 'stl-product__info';
    var label = document.createElement('span');
    label.className = 'stl-product__own-label';
    label.textContent = str('inYourCart', 'In your cart');
    info.appendChild(label);
    var nameEl = item.querySelector('.cart__item-name');
    if (nameEl) {
      var titleEl = document.createElement('span');
      titleEl.className = 'stl-product__own-title';
      titleEl.textContent = nameEl.textContent.trim();
      info.appendChild(titleEl);
    }
    own.appendChild(info);
    wrap.appendChild(own);

    wrap.appendChild(tpl.content.cloneNode(true));
    clearRail();
    bodyEl.replaceChildren(wrap);
    enhanceSizeRows(wrap);
    if (scrollEl) scrollEl.scrollTop = 0;
    if (railEl) railEl.scrollTop = 0;

    var back = document.createElement('button');
    back.type = 'button';
    back.className = 'side-drawer__btn side-drawer__btn--muted';
    back.setAttribute('data-side-drawer-close', '');
    back.textContent = str('back', 'Back');
    setFooter([back]);
    openDrawer();
  }

  // --- Variant + add helpers (shared by both modes) ---
  function variantIdFor(row) {
    var sizes = row.querySelector('[data-stl-sizes]');
    if (!sizes) return null;
    if (sizes.dataset.singleVariant) return sizes.dataset.singleVariant;
    var selected = sizes.querySelector('[data-stl-size].is-selected');
    return selected ? selected.dataset.variantId : null;
  }

  function addItems(items) {
    window.suppressCartNotification = true;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) { throw new Error('Shop-the-look add failed: ' + r.status); }
      return r.json();
    });
  }

  function markAdded(btn) {
    btn.classList.add('is-added');
    btn.textContent = btn.dataset.addedLabel;
  }

  function addOne(addBtn) {
    var row = addBtn.closest('[data-stl-product]');
    if (!row) return;
    var vid = variantIdFor(row);
    if (!vid) {
      var sizesEl = row.querySelector('[data-stl-sizes]');
      if (sizesEl) { sizesEl.classList.add('is-missing-size'); }
      return;
    }
    addBtn.classList.add('is-loading');
    addItems([{ id: vid, quantity: 1 }])
      .then(function (data) {
        addBtn.classList.remove('is-loading');
        markAdded(addBtn);
        document.dispatchEvent(new CustomEvent('cart:build'));
        if (window.location.pathname === (theme.routes && theme.routes.cartUrl || '/cart')) {
          window.location.reload();
          return;
        }
        // Re-open the confirmation on the product just added, so the cart visibly updates.
        var added = data && data.items && data.items[0];
        if (added) { openNotification(added); }
      })
      .catch(function (err) {
        addBtn.classList.remove('is-loading');
        console.error(err);
      });
  }

  // --- Size picker sheet (upsell "Mere til dig" cards) ---
  function isSingleVariant(card) {
    var sizes = card.querySelector('[data-stl-sizes]');
    return !!(sizes && sizes.dataset.singleVariant);
  }

  function openSizeSheet(card) {
    if (!sizeSheet) return;
    var sizesEl = card.querySelector('[data-stl-sizes]');
    var titleLink = card.querySelector('.stl-product__title');
    sheetProductLink.href = titleLink ? titleLink.getAttribute('href') : '#';
    // Show the card's packshot on top so the sheet covers the whole drawer.
    var cardImg = card.querySelector('.stl-product__image-main');
    sheetMedia.classList.remove('is-loaded');
    sheetImage.src = cardImg ? cardImg.dataset.sizeSheetSrc : '';
    sheetImage.alt = cardImg ? cardImg.alt : '';
    sheetVariant = null;
    sheetAddBtn.disabled = true;
    sheetList.replaceChildren();
    var sourceSizes = sizesEl ? sizesEl.querySelectorAll('[data-stl-size]') : [];
    sourceSizes.forEach(function (b) {
      var row = document.createElement('button');
      row.type = 'button';
      row.className = 'size-sheet__size';
      row.setAttribute('data-size-sheet-size', '');
      row.dataset.variantId = b.dataset.variantId;
      // Label sits in its own span so the selected highlight hugs the text.
      var lbl = document.createElement('span');
      lbl.className = 'size-sheet__size-label';
      lbl.textContent = b.textContent.trim();
      row.appendChild(lbl);
      if (b.disabled) { row.disabled = true; row.classList.add('size-sheet__size--unavailable'); }
      sheetList.appendChild(row);
    });
    // Preselect the first available size, mirroring the card default.
    var firstAvail = sheetList.querySelector('.size-sheet__size:not(.size-sheet__size--unavailable)');
    if (firstAvail) {
      firstAvail.classList.add('is-selected');
      sheetVariant = firstAvail.dataset.variantId;
      sheetAddBtn.disabled = false;
    }
    sheetList.scrollTop = 0;
    sizeSheet.classList.add('is-open');
    sizeSheet.setAttribute('aria-hidden', 'false');
    if (sizeSheetPanel) sizeSheetPanel.setAttribute('aria-modal', 'false');
  }

  function closeSizeSheet() {
    if (!sizeSheet) return;
    sizeSheet.classList.remove('is-open');
    sizeSheet.setAttribute('aria-hidden', 'true');
    // Drop the packshot so the next product never flashes the previous one.
    sheetImage.removeAttribute('src');
    if (sizeSheetPanel) sizeSheetPanel.setAttribute('aria-modal', 'false');
  }

  function addFromSheet() {
    if (!sheetVariant) return;
    sheetAddBtn.disabled = true;
    // Dismiss immediately so the sheet cannot sit on the confirm
    // while /cart/add.js is in flight.
    closeSizeSheet();
    addItems([{ id: sheetVariant, quantity: 1 }])
      .then(function (data) {
        document.dispatchEvent(new CustomEvent('cart:build'));
        closeSizeSheet();
        if (window.location.pathname === (theme.routes && theme.routes.cartUrl || '/cart')) {
          window.location.reload();
          return;
        }
        var added = data && data.items && data.items[0];
        if (added) { openNotification(added); }
      })
      .catch(function (err) {
        sheetAddBtn.disabled = false;
        console.error(err);
      });
  }

  // --- Hide a Shop the look trigger once the cart holds every look product ---
  function syncTriggers() {
    if (typeof theme === 'undefined' || !theme.cart) return;
    theme.cart.getCart().then(function (cart) {
      var inCart = {};
      cart.items.forEach(function (item) { inCart[String(item.product_id)] = true; });
      document.querySelectorAll('[data-stl-trigger]').forEach(function (trigger) {
        var ids = (trigger.dataset.stlProducts || '').split(',').filter(Boolean);
        var allInCart = ids.length > 0 && ids.every(function (id) { return inCart[id]; });
        trigger.classList.toggle('hide', allInCart);
      });
    });
  }

  // --- Notification mode (triggered by an add from outside any drawer) ---
  function buildConfirm(line) {
    var money = theme.Currency.formatMoney(line.final_price || line.price, theme.settings.moneyFormat);
    var imgUrl = (line.featured_image && line.featured_image.url) ? line.featured_image.url : (line.image || '');
    var wrap = document.createElement('div');
    wrap.className = 'side-drawer__confirm';
    // The packshot must be the first image ever loaded, so the img starts
    // without a src; openNotification fills it in once the packshot fetch
    // resolves, falling back to the variant image only if no packshot exists.
    var media = document.createElement('div');
    media.className = 'side-drawer__confirm-media';
    var img = document.createElement('img');
    img.className = 'side-drawer__confirm-img';
    img.alt = '';
    if (imgUrl) { img.setAttribute('data-fallback-src', imgUrl); }
    media.appendChild(img);
    wrap.appendChild(media);
    // One row under the image: "STR: <size> <title>" on the left, price on the right.
    var row = document.createElement('div');
    row.className = 'side-drawer__confirm-row';
    var info = document.createElement('div');
    info.className = 'side-drawer__confirm-info';
    var sizeValue = lineSize(line);
    if (sizeValue) {
      var size = document.createElement('span');
      size.className = 'side-drawer__confirm-size';
      // "STR:" stays normal weight, the size value is bold.
      size.appendChild(document.createTextNode(str('sizePrefix', 'SIZE:') + ' '));
      var sizeVal = document.createElement('b');
      sizeVal.textContent = sizeValue;
      size.appendChild(sizeVal);
      info.appendChild(size);
    }
    var name = document.createElement('span');
    name.className = 'side-drawer__confirm-name';
    name.textContent = line.product_title || '';
    info.appendChild(name);
    var price = document.createElement('span');
    price.className = 'side-drawer__confirm-price';
    price.textContent = money;
    row.appendChild(info);
    row.appendChild(price);
    wrap.appendChild(row);
    return wrap;
  }

  function goToCartButton() {
    var cartUrl = (window.theme && theme.routes && theme.routes.cartPage) ? theme.routes.cartPage : '/cart';
    var go = document.createElement('a');
    go.href = cartUrl;
    go.className = 'side-drawer__btn side-drawer__btn--primary side-drawer__go-to-cart';
    go.textContent = str('goToCart', 'Go to cart');
    return go;
  }

  function notificationFooter() {
    // "Shop videre" only closes the drawer, same as the X.
    var cont = document.createElement('button');
    cont.type = 'button';
    cont.className = 'side-drawer__btn side-drawer__btn--ghost';
    cont.setAttribute('data-side-drawer-close', '');
    cont.textContent = str('continueShopping', 'Continue shopping');
    return [cont, goToCartButton()];
  }

  function fetchUpsell(line) {
    var handle = line.handle || (line.url ? line.url.split('?')[0].split('/').pop() : '');
    function recs(intent) {
      return fetch('/recommendations/products?section_id=cart-upsell&intent=' + intent + '&limit=8&product_id=' + line.product_id, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); });
    }
    var productPromise = fetch('/products/' + handle + '?section_id=cart-upsell', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); });
    var recsPromise = recs('complementary').then(function (h) {
      if (h.indexOf('data-upsell-list-recs') !== -1) return h;
      return recs('related');
    });
    return Promise.all([productPromise, recsPromise]).then(function (parts) {
      return { productHtml: parts[0], recsHtml: parts[1] };
    });
  }

  function openNotification(line) {
    // Confirm/notification and the size-sheet must not stack. Close on
    // every successful ATC path (PDP hook, sheet add, single-variant).
    closeSizeSheet();
    drawer.classList.remove('side-drawer--stl');
    setTitle(str('addedToCart', 'Added to cart'));
    setCount(null);
    clearRail();
    bodyEl.replaceChildren(buildConfirm(line));
    setFooter(notificationFooter());
    openDrawer();
    closeSizeSheet();
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && cart.item_count) { setTitle(str('addedToCart', 'Added to cart'), cart.item_count); }
      })
      .catch(function (err) { console.error(err); });
    fetchUpsell(line).then(function (parts) {
      if (!drawer.classList.contains('is-open')) return;
      var productDoc = new DOMParser().parseFromString(parts.productHtml, 'text/html');
      var recsDoc = new DOMParser().parseFromString(parts.recsHtml, 'text/html');
      var packshotEl = productDoc.querySelector('[data-current-packshot]');
      var media = bodyEl.querySelector('.side-drawer__confirm-media');
      var mainImg = media && media.querySelector('.side-drawer__confirm-img');
      var packshotUrl = packshotEl ? packshotEl.getAttribute('data-current-packshot') : '';
      if (mainImg) {
        var confirmSrc = packshotUrl || mainImg.getAttribute('data-fallback-src');
        if (confirmSrc) {
          mainImg.addEventListener('load', function () {
            mainImg.classList.add('is-loaded');
          }, { once: true });
          mainImg.src = confirmSrc;
        }
      }
      var stlList = productDoc.querySelector('[data-upsell-list-stl]');
      var recsList = recsDoc.querySelector('[data-upsell-list-recs]');
      var stlIds = {};
      if (stlList) {
        stlList.querySelectorAll('[data-product-id]').forEach(function (el) {
          stlIds[el.getAttribute('data-product-id')] = true;
        });
        // All items sold out and filtered server-side: drop the empty section.
        if (!stlList.querySelector('[data-product-id]')) stlList = null;
      }
      if (recsList) {
        recsList.querySelectorAll('[data-product-id]').forEach(function (el) {
          if (stlIds[el.getAttribute('data-product-id')]) el.remove();
        });
        if (!recsList.querySelector('[data-product-id]')) recsList = null;
      }
      // Merge Shop-the-look and recommendations into one list: STL cards lead, recs follow.
      var combined = document.createElement('div');
      combined.className = 'stl-look stl-look--upsell';
      [stlList, recsList].forEach(function (list) {
        if (!list) return;
        list.querySelectorAll('[data-stl-product]').forEach(function (card) {
          combined.appendChild(document.importNode(card, true));
        });
      });
      if (combined.children.length && railEl) {
        var label = document.createElement('p');
        label.className = 'side-drawer__section-label';
        label.textContent = str('upsellFallbackTitle', 'More for you');
        var track = document.createElement('div');
        track.className = 'side-drawer__rail-track';
        track.setAttribute('data-ios-scroll', 'x');
        track.appendChild(combined);
        // Title stays a static sibling of the X track. The rail itself is
        // the ATC Y-scroller (confirm stays fixed).
        railEl.replaceChildren(label, track);
        railEl.hidden = false;
        railEl.setAttribute('data-ios-scroll', 'y');
        enhanceSizeRows(combined);
        bindCartHScroll(track);
        track.scrollLeft = 0;
        railEl.scrollTop = 0;
      }
    }).catch(function (err) {
      // Packshot fetch failed: fall back to the variant image so the media
      // box does not stay empty.
      var mainImg = bodyEl.querySelector('.side-drawer__confirm-img');
      if (mainImg && !mainImg.src) {
        var fallbackSrc = mainImg.getAttribute('data-fallback-src');
        if (fallbackSrc) {
          mainImg.addEventListener('load', function () {
            mainImg.classList.add('is-loaded');
          }, { once: true });
          mainImg.src = fallbackSrc;
        }
      }
      console.error(err);
    });
  }

  // --- Events ---
  drawer.addEventListener('click', function (evt) {
    // Close + unlock before any in-drawer navigation (product links, Gå til kurv).
    var navLink = evt.target.closest('a[href]');
    if (navLink) {
      var href = navLink.getAttribute('href') || '';
      if (href && href !== '#' && href.indexOf('javascript:') !== 0) {
        closeDrawer();
      }
    }

    // Size sheet overlays the drawer, so handle its interactions first.
    if (evt.target.closest('[data-size-sheet-close]')) { closeSizeSheet(); return; }
    var sheetSize = evt.target.closest('[data-size-sheet-size]');
    if (sheetSize && !sheetSize.disabled) {
      sheetList.querySelectorAll('.size-sheet__size').forEach(function (s) { s.classList.remove('is-selected'); });
      sheetSize.classList.add('is-selected');
      sheetVariant = sheetSize.dataset.variantId;
      sheetAddBtn.disabled = false;
      return;
    }
    if (evt.target.closest('[data-size-sheet-add]')) { addFromSheet(); return; }

    if (evt.target.closest('[data-side-drawer-close]')) { closeDrawer(); return; }

    var size = evt.target.closest('[data-stl-size]');
    if (size && !size.disabled) {
      var group = size.closest('[data-stl-sizes]');
      group.querySelectorAll('[data-stl-size]').forEach(function (b) { b.classList.remove('is-selected'); });
      size.classList.add('is-selected');
      group.classList.remove('is-missing-size');
      return;
    }

    var addBtn = evt.target.closest('[data-stl-add]');
    if (addBtn && !addBtn.classList.contains('is-added')) {
      // Upsell cards open a size sheet; Shop-the-look cards add directly.
      var card = addBtn.closest('[data-stl-product]');
      if (addBtn.closest('.stl-look--upsell') && card && !isSingleVariant(card)) { openSizeSheet(card); }
      else { addOne(addBtn); }
      return;
    }
  });

  document.addEventListener('click', function (evt) {
    var trigger = evt.target.closest('[data-stl-trigger]');
    if (trigger) { evt.preventDefault(); openShopTheLook(trigger); }
  });

  document.addEventListener('keydown', function (evt) {
    if (evt.key !== 'Escape') return;
    if (sizeSheet && sizeSheet.classList.contains('is-open')) { closeSizeSheet(); return; }
    if (drawerIsOpen()) { closeDrawer(); }
  });

  // Theme ATC popup is this #SideDrawer in notification mode:
  // ProductForm.success → /cart/add.js → fetch/XHR hook → openCartNotification
  // → openNotification → #SideDrawer.is-open. There is no separate cart-notification
  // snippet. App leftovers (#slidecarthq, #upsell-options-overlay) are forced hidden.
  window.openCartNotification = openNotification;
  window.closeSideDrawerSizeSheet = closeSizeSheet;

  // Re-sync triggers whenever the cart re-renders.
  var productsEl = document.querySelector('[data-products]');
  if (productsEl) {
    new MutationObserver(syncTriggers).observe(productsEl, { childList: true });
  }
  document.addEventListener('cart:updated', syncTriggers);
  document.addEventListener('cart:build', syncTriggers);

  // Keep the header count fresh while the notification badge is visible.
  document.addEventListener('cart:updated', function () {
    if (countEl && !countEl.hidden) { showCartCount(); }
  });

  syncTriggers();

  window.addEventListener('pageshow', function (evt) {
    if (evt.persisted) { forceUnlockPage(); return; }
    if (window.scPageLock) window.scPageLock.sync();
  });
})();

// Catch add-to-cart requests (fetch OR XHR) from outside the drawer and open
// the notification. Cart apps may add via XMLHttpRequest, so both are hooked.
(function () {
  if (window.cartAddHookReady) return;
  window.cartAddHookReady = true;

  function isCartAdd(url) {
    return typeof url === 'string' && url.indexOf('/cart/add') !== -1;
  }

  // Open the notification from a parsed /cart/add response.
  function handleCartAdd(data) {
    var suppressed = window.suppressCartNotification === true;
    window.suppressCartNotification = false;
    document.dispatchEvent(new CustomEvent('cart:build'));
    // Always drop a leftover size-sheet on successful ATC, even when
    // the drawer IIFE will re-open the confirm itself (suppressed).
    if (typeof window.closeSideDrawerSizeSheet === 'function') {
      window.closeSideDrawerSizeSheet();
    } else {
      var leftover = document.querySelector('#SideDrawer .size-sheet.is-open');
      if (leftover) {
        leftover.classList.remove('is-open');
        leftover.setAttribute('aria-hidden', 'true');
      }
    }
    if (suppressed || typeof window.openCartNotification !== 'function') return;
    if (!data) return;
    var line = (data.items && data.items.length) ? data.items[0] : data;
    if (line && line.product_title) { window.openCartNotification(line); }
  }

  if (typeof window.fetch === 'function') {
    var nativeFetch = window.fetch;
    window.fetch = function (input) {
      var url = (typeof input === 'string' ? input : (input && input.url)) || '';
      var result = nativeFetch.apply(window, arguments);
      if (isCartAdd(url)) {
        result.then(function (response) {
          if (!response || !response.ok) return;
          return response.clone().json().then(handleCartAdd);
        }).catch(function (err) { console.error(err); });
      }
      return result;
    };
  }

  var nativeOpen = XMLHttpRequest.prototype.open;
  var nativeSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.cartAddTracked = isCartAdd(url);
    return nativeOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this.cartAddTracked) {
      var xhr = this;
      xhr.addEventListener('load', function () {
        if (xhr.status < 200 || xhr.status >= 300) return;
        var data;
        try { data = JSON.parse(xhr.responseText); } catch (e) { return; }
        handleCartAdd(data);
      });
    }
    return nativeSend.apply(this, arguments);
  };
})();

// Optional HUD for iOS scroll-lock hunts. Enable with ?scrolldbg=1 only.
// Never attach a MutationObserver to the HUD; scPageLock also ignores #scrolldbg.
(function () {
  var enabled = false;
  try { enabled = /(?:^|[?&])scrolldbg=1(?:&|$)/.test(window.location.search); } catch (err) { return; }
  if (!enabled) return;

  var hud = document.createElement('div');
  hud.id = 'scrolldbg';
  hud.setAttribute('aria-hidden', 'true');
  hud.style.cssText = 'position:fixed;z-index:2147483647;left:8px;bottom:8px;max-width:94vw;font:11px/1.35 ui-monospace,monospace;background:rgba(0,0,0,.82);color:#7dff9a;padding:8px 10px;pointer-events:none;white-space:pre-wrap;border-radius:4px;';
  document.documentElement.appendChild(hud);

  function snap() {
    if (!hud || !hud.isConnected) return;
    var html = document.documentElement;
    var body = document.body;
    if (!body) return;
    var hs = window.getComputedStyle(html);
    var bs = window.getComputedStyle(body);
    var drawer = document.getElementById('SideDrawer');
    var panel = drawer && drawer.querySelector('.side-drawer__panel');
      var rail = drawer && drawer.querySelector('[data-side-drawer-rail]');
      var track = drawer && drawer.querySelector('.side-drawer__rail-track');
      var ps = panel ? window.getComputedStyle(panel) : null;
      var rs = rail ? window.getComputedStyle(rail) : null;
      var ts = track ? window.getComputedStyle(track) : null;
    var scroll = drawer && drawer.querySelector('[data-side-drawer-scroll]');
    var ss = scroll ? window.getComputedStyle(scroll) : null;
    var sheet = drawer && drawer.querySelector('.size-sheet');
    var sheetList = drawer && drawer.querySelector('[data-size-sheet-list]');
    var ds = drawer ? window.getComputedStyle(drawer) : null;
    var sls = sheetList ? window.getComputedStyle(sheetList) : null;
    var apps = ['slidecarthq', 'upsell-options-overlay', 'CartDrawer'].map(function (id) {
      var n = document.getElementById(id);
      if (!n) return id + '=absent';
      var cs = window.getComputedStyle(n);
      return id + '=' + cs.display + '/' + cs.pointerEvents;
    });
    hud.textContent = [
      'scrollY=' + (window.scrollY || window.pageYOffset || 0),
      'html.class=' + html.className,
      'html.ov=' + hs.overflow + ' pos=' + hs.position + ' ta=' + hs.touchAction,
      'body.style.ov=' + (body.style.overflow || '') + ' pos=' + (body.style.position || '') + ' top=' + (body.style.top || ''),
      'body.computed.ov=' + bs.overflow + ' pos=' + bs.position + ' top=' + bs.top,
      'lock.applied=' + !!(window.scPageLock && window.scPageLock.isApplied && window.scPageLock.isApplied())
        + ' savedY=' + (window.scPageLock && window.scPageLock.savedY ? window.scPageLock.savedY() : ''),
      'modalOpen=' + !!(window.scPageLock && window.scPageLock.themeModalOpen && window.scPageLock.themeModalOpen()),
      'drawer=' + (drawer ? (drawer.isConnected ? 'in-dom' : 'detached') : 'missing')
        + ' open=' + !!(drawer && drawer.classList.contains('is-open'))
        + ' pos=' + (ds ? ds.position : ''),
      'drawer.inert=' + !!(drawer && drawer.classList.contains('is-inert')),
      'drawer.box=' + (ds ? ds.top + '/' + ds.bottom + ' h=' + ds.height + ' w=' + ds.width : ''),
      'panel.pos=' + (ps ? ps.position : '')
        + ' display=' + (ps ? ps.display : '')
        + ' ov=' + (ps ? ps.overflowX + '/' + ps.overflowY : '')
        + ' h=' + (ps ? ps.height : '')
        + ' tf=' + (ps ? ps.transform : ''),
      'yscroll.ovY=' + (ss ? ss.overflowY : '')
        + ' ovX=' + (ss ? ss.overflowX : '')
        + ' ta=' + (ss ? ss.touchAction : '')
        + ' pos=' + (ss ? ss.position : '')
        + ' h=' + (ss ? ss.height : '')
        + ' st=' + (scroll ? scroll.scrollTop : ''),
      'railInsideY=' + !!(scroll && rail && scroll.contains(rail)),
      'rail.ovX=' + (rs ? rs.overflowX : '')
        + ' ta=' + (rs ? rs.touchAction : '')
        + ' sl=' + (rail ? rail.scrollLeft : '')
        + ' sw/cw=' + (rail ? rail.scrollWidth + '/' + rail.clientWidth : ''),
      'track.ovX=' + (ts ? ts.overflowX : '')
        + ' ta=' + (ts ? ts.touchAction : '')
        + ' sl=' + (track ? track.scrollLeft : '')
        + ' sw/cw=' + (track ? track.scrollWidth + '/' + track.clientWidth : ''),
      'sheet.open=' + !!(sheet && sheet.classList.contains('is-open'))
        + ' list.ovY=' + (sls ? sls.overflowY : ''),
      'apps ' + apps.join(' ')
    ].join('\n');
  }

  ['touchstart', 'touchend', 'scroll', 'click', 'keyup'].forEach(function (type) {
    window.addEventListener(type, snap, { passive: true });
  });
  window.setInterval(snap, 500);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', snap);
  } else {
    snap();
  }
})();
